export function AutoUnsubscribe(blackList = []) {

    return function (constructor) {
        const original = constructor.prototype.ngOnDestroy;

        constructor.prototype.ngOnDestroy = function () {
            for (let prop in this) {
                const property = this[prop];
                if (!blackList.includes(prop)) {

                    if(property){
                        if(property instanceof Array){
                            for(let i=0; i< property.length; i++){
                                let subscribe = property[i];
                                if(subscribe && typeof subscribe.unsubscribe === "function"){
                                    subscribe.unsubscribe();
                                }
                            }
                        }else{
                            if (typeof property.unsubscribe === "function") {
                                property.unsubscribe();
                            }
                        }
                    }



                }
            }
            original && typeof original === 'function' && original.apply(this, arguments);
        };
    }

}